import { EndgameContent } from "../../models/enums";
import { RestrictedDropEntry } from "../../models/item-data-models";

export const restrictedDropData: RestrictedDropEntry[] = [
  {
    type: "Genesis Tree (Breach)",
    content: EndgameContent.Breach,
    baseTypes: [
      "Absent Amulet", "Corona Amulet", "Lament Amulet", "Portent Amulet",
      "Breach Ring", "Refined Breach Ring",
      "Biostatic Ring", "Vitalic Ring", "Mnemonic Ring", "Kinetic Ring", "Oneiric Ring", "Grasping Ring",
      "Stalking Belt", "Invoking Belt", "Sinew Belt", "Forking Belt",
    ],
  },
  {
    type: "The Fractured Lake (Unique Map)",
    content: EndgameContent.UniqueMap,
    baseTypes: [
      "Tenebrous Amulet", "Penumbra Amulet", "Dusk Amulet", "Gloam Amulet",
      "Tenebrous Ring", "Penumbra Ring", "Dusk Ring", "Gloam Ring",
    ],
  },
  {
    type: "Reforging Bench",
    content: EndgameContent.Crafting,
    baseTypes: [
      "Pearlescent Amulet"
    ],
  },
  {
    type: "Loathsome Mire (Delirium)",
    content: EndgameContent.Delirium,
    baseTypes: [
      "Twisted Amulet", "Distorted Amulet",
    ],
  },
  {
    type: "Atziri's Vault (Temple)",
    content: EndgameContent.Temple,
    baseTypes: [
      "Sacrificial Regalia",
    ],
  },
  {
    type: "Grasping Orchid (Breach)",
    content: EndgameContent.Breach,
    baseTypes: [
      "Grasping Mail",
    ],
  },
]
